// Removed — onboarding sign endpoints no longer exist  
export function* watchSign() {}
